module.exports = __webpack_public_path__ + "static/media/password-protected-group.89fc3523.svg";